<template>
  <section class="privacypolicy">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>Privacy Policy (プライバシーポリシー)</h1>
          <vue-markdown :source="source"></vue-markdown>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import text from 'raw-loader!./PrivacyPolicy.md';

export default {
  name: 'PrivacyPolicy',
  components: {
    VueMarkdown,
  },
  data() {
    return {
      source: '',
    };
  },
  mounted() {
    scrollTo(0, 0);
    this.source = text;
  },
}
</script>

<style scoped lang="scss">
h1 {
  margin-bottom:2rem;
}
section {
  text-align: left;
  margin: 3rem 0;
}
</style>